import { Component, Input, OnInit } from '@angular/core';
import { Device } from '@app/shared/models/device';

@Component({
    selector: 'app-file-extension',
    templateUrl: './file-extension.component.html',
    styleUrls: ['./file-extension.component.scss']
})
export class FileExtensionComponent implements OnInit {
    @Input() device: Device;
    @Input() fileExtension?: string = '...';
    @Input() fileType: string;

    constructor() {
    }

    ngOnInit(): void {
        if (!this.fileExtension)
            this.fileExtension = '...';
    }
}
